import i18n from '@/plugins/i18n';

const kafkaOverviewMetricsData = () => [
  {
    metricName: 'kafka_active_broker_count',
    className: 'bg-dark-black info-cards',
    textLabel: i18n.global.t('mq.noOfBrokers'),
    textValColor: 'tangerine',
    textValue: '0',
    dataType: 'string',
  },
  {
    metricName: 'kafka_broker_global_topic_count',
    className: 'bg-dark-black info-cards',
    textLabel: i18n.global.t('mq.noOfTopics'),
    textValColor: 'tangerine',
    textValue: '0',
  },
  {
    metricName: 'kafka_broker_global_partition_count',
    className: 'bg-dark-black info-cards',
    textLabel: i18n.global.t('mq.avgNoOfPartitions'),
    textValColor: 'tangerine',
    textValue: '0',
  },
  {
    metricName: 'kafka_producer_producer_count',
    className: 'bg-dark-black info-cards',
    textLabel: i18n.global.t('mq.noOfProducers'),
    textValColor: 'tangerine',
    textValue: '0',
  },
  {
    metricName: 'kafka_consumer_consumer_count',
    className: 'bg-dark-black info-cards',
    textLabel: i18n.global.t('mq.noOfConsumers'),
    textValColor: 'tangerine',
    textValue: '0',
  },
];

export { kafkaOverviewMetricsData };
